module.exports = __webpack_public_path__ + "img/icon-photo.61c0a42e.png";